import { Check } from 'lucide-react';
import { billSelectedToggleClass, billUnselectedToggleClass } from '@/components/bills/billPaymentUtils';
import { cn } from '@/utils/cn';

interface BillToggleGroupProps<T extends string> {
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
}

export function BillToggleGroup<T extends string>({
  value,
  options,
  onChange,
}: BillToggleGroupProps<T>) {
  return (
    <div className={cn('grid gap-2', options.length === 2 ? 'grid-cols-2' : 'grid-cols-1')}>
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              'relative rounded-xl border-2 px-4 py-3.5 text-center text-sm font-medium transition-all',
              isSelected ? billSelectedToggleClass : billUnselectedToggleClass,
            )}
          >
            {option.label}
            {isSelected && (
              <span className="absolute bottom-2 right-2 flex h-5 w-5 items-center justify-center rounded-full bg-secondary-500 text-white">
                <Check className="h-3 w-3" />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
